import React, { useEffect, useState } from 'react';
import { Table, Spin, Typography, message, Button, InputRef, Input, Space } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { formatNumberWithCommas, formatToTwoDecimalPlaces, rejectedApiMessage } from '../../utilities/CommonHelper';
import { fetchOBOReport_AllSOWs } from '../../store/reducers/oboDashboardSlice';
import { ColumnType, FilterConfirmProps, TablePaginationConfig } from 'antd/es/table/interface';
import Highlighter from 'react-highlight-words';
import { SearchOutlined } from '@ant-design/icons';


const { Title } = Typography;

interface OboSowDetailsTableContainerProps {
  parentOpp: any; // Parent opportunity data passed as props
  filterData : any;
  fetchWorkOrderDetails: (data: any, level: any) => void;
}

interface DataType_sowColumns  {
    key :React.Key;
    sowid: string;
    sowStartDate: string;
    sowEndDate: string;
    sumOfTCV: string;
    revenue: string;
    totalRevenue: string;
    obo: string;
    countOfWorkOrder: any;
    
  }
  type DataIndex_sowColumns = keyof DataType_sowColumns;

const OboSowDetailsTableContainer: React.FC<OboSowDetailsTableContainerProps> = ({ parentOpp,filterData, fetchWorkOrderDetails }) => {
    const dispatch = useDispatch();
    const oboReportsData = useSelector((state: any) => state.oboReports);
    const [sowData, setSowData] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(false);

    const [searchText, setSearchText] = React.useState('');
	  const [searchedColumn, setSearchedColumn] = React.useState('');
    const searchInput = React.useRef<InputRef>(null);

    const [pageNo, setPageNo] = React.useState<number>(0);
    const [pageSize, setPageSize] = React.useState<number>(10);
    const [totalCount, setTotalCount] = React.useState<number>(0);
    const [filters, setFilters] = React.useState<any>([]);
    
    
    const handleTableChange = (pagination: TablePaginationConfig,filters:any) => {
          const { current, pageSize } = pagination;
          const _current = current ? current - 1 : 0;
          setPageNo(_current);
          setPageSize(pageSize || 10);
          const _filters:any[] =[];
           Object.keys(filters).map((key) => {
            debugger;
            if(filters[key] && filters[key]!==undefined ){
      
            if(key==="sowid"){
              _filters.push({field:key,value:filters[key][0],operator:'EQUALS'});
            }
            else{
              _filters.push({field:key,value:filters[key][0],operator:'LIKE'});
            }
            
            }
          })
          setFilters(_filters);
          dispatch(fetchOBOReport_AllSOWs({
            'payload':{'opportunityID':parentOpp.opportunityID,'startDate':oboReportsData.filterData.startDate,'endDate': oboReportsData.filterData.endDate,
                'isParent': parentOpp.level== "parent opportunity"?true:false,
                'page':_current,
                'size':pageSize,
                'filters':_filters
            }
            })).then((res:any) => {
            if(res.type!=="oboReports/fetchOBOReport_AllSOWs/fulfilled"){
                rejectedApiMessage(res.payload);
                setLoading(false);

                
                
            }
            else{
                let _temp = addkeytoData(res.payload.content);
                setSowData(_temp);
                setLoading(false);
                setTotalCount(res.payload?.totalElements);
           		  setPageNo(_current);
            }

        }
    );
      };


	const handleSearch = (
		selectedKeys: string[],
		confirm: (param?: FilterConfirmProps) => void,
		dataIndex: DataIndex_sowColumns,
	  ) => {
		confirm();
		setSearchText(selectedKeys[0]);
		setSearchedColumn(dataIndex);
	  };
	  
	  const handleReset = (clearFilters: () => void) => {
		clearFilters();
		setSearchText('');
	  };
	  const getColumnSearchProps = (dataIndex: DataIndex_sowColumns): ColumnType<any> => ({
		filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
		  <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
		  <Input
		  ref={searchInput}
		  placeholder={`Search ${dataIndex}`}
		  value={selectedKeys[0]}
		  onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
		  onPressEnter={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
		  style={{ marginBottom: 8, display: 'block' }}
		  />
		  <Space>
		  <Button
		  type="primary"
		  onClick={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
		  icon={<SearchOutlined />}
		  size="small"
		  style={{ width: 90 }}
		  >
		  Search
		  </Button>
		  <Button
		  onClick={() => {
			setSelectedKeys([]);
			handleSearch([], confirm, dataIndex);
		  }}
		  size="small"
		  style={{ width: 90 }}
		  >
		  Reset
		  </Button>
		  </Space>
		  </div>
		),
		filterIcon: (filtered: boolean) => (
		  <SearchOutlined style={{ color: filtered ? '#1677ff' : undefined }} />
		),
		onFilter: (value, record) =>
		  record[dataIndex] && record[dataIndex]
		.toString()
		.toLowerCase()
		.includes((value as string).toLowerCase()),
		onFilterDropdownOpenChange: (visible) => {
		  if (visible) {
			setTimeout(() => searchInput.current?.select(), 100);
		  }
		},
		render: (text) =>
		  searchedColumn === dataIndex ? (
		  <Highlighter
		  highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
		  searchWords={[searchText]}
		  autoEscape
		  textToHighlight={text ? text.toString() : ''}
		  />
		) : (
		  text
		),
	  });


    const addkeytoData = (data:any) => {
		let tempData = [...data];
		tempData.map((item:any,index:number) => {
			item.key = index+1;
		});
		return tempData;
	}

    useEffect(() => {
        if (parentOpp && parentOpp.opportunityID && oboReportsData.filterData.startDate && oboReportsData.filterData.endDate) {
          fetchSowData();
        }
      }, [parentOpp,oboReportsData.filterData.startDate,oboReportsData.filterData.endDate]);
      
  const fetchSowData = async () => {
    setLoading(true);

    dispatch(fetchOBOReport_AllSOWs({
            'payload':{'opportunityID':parentOpp.opportunityID,'startDate':oboReportsData.filterData.startDate,'endDate': oboReportsData.filterData.endDate,
                'isParent': parentOpp.level== "parent opportunity"?true:false,
                'page':0,
                'size':10,
                'filters':filters
            }
            })).then((res:any) => {
            if(res.type==="oboReports/fetchOBOReport_AllSOWs/fulfilled"){
                if(res.payload.content?.length>0){
                    let _temp = addkeytoData(res.payload.content);
                    setSowData(_temp);
                    setTotalCount(res.payload?.totalElements);
                }
                else{
                    message.success("No SOW data available for this opportunity.");
                }
                setLoading(false);
            }
            else{
                rejectedApiMessage(res.payload);
                setLoading(false);
            }

        }
    );
}



  const parentColumns = [
    {
      title: 'Opportunity ID',
      dataIndex: 'opportunityID',
      key: 'opportunityID',
      
    },
    {
      title: 'Opportunity Name',
      dataIndex: 'opportunityName',
      key: 'opportunityName',
      width: '150px',
    },
    {
      title: 'Client Name',
      dataIndex: 'client',
      key: 'client',
      width:'150px'
    },
    {
      title: 'Contract Value',
      dataIndex: 'sumOfTCV',
      key: 'sumOfTCV',
      render: (text: any, record: any) => {
              return(
                <span>{`$${formatNumberWithCommas(formatToTwoDecimalPlaces(text))}`}</span>
              )
         }
    },
    {
      title: 'Revenue For Period',
      dataIndex: 'revenue',
      key: 'revenue',
      render: (text: any, record: any) => {
              return(
                <span>{`$${formatNumberWithCommas(formatToTwoDecimalPlaces(text))}`}</span>
              )
        }
    },
    {
        title: 'Total Revenue',
        dataIndex: 'totalRevenue',
        key: 'totalRevenue',
        render: (text: any, record: any) => {
                return(
                  <span>{`$${formatNumberWithCommas(formatToTwoDecimalPlaces(text))}`}</span>
                )
            }
      },
      {
        title: 'OBO Value',
        dataIndex: 'obo',
        key: 'obo',
        render: (text: any, record: any) => {
                return(
                  <span>{`$${formatNumberWithCommas(formatToTwoDecimalPlaces(text))}`}</span>
                )
            }
      }
  ];

  const sowColumns = [
    {
      title: 'SOW ID',
      dataIndex: 'sowid',
      key: 'sowid',
      ...getColumnSearchProps('sowid'),
    },
    {
      title: 'SOW Start Date',
      dataIndex: 'sowStartDate',
      key: 'sowStartDate',
    },
    {
        title: 'SOW End Date',
        dataIndex: 'sowEndDate',
        key: 'sowEndDate',
      },
    {
      title: 'Contract Value',
      dataIndex: 'sumOfTCV',
      key: 'sumOfTCV',
      render: (text: any, record: any) => {
        return(
          <span>{`$${formatNumberWithCommas(formatToTwoDecimalPlaces(text))}`}</span>
        )
    }
    //   render: (text: any) => `$${text.toLocaleString()}`,
    },
    {
      title: 'Revenue For Period',
      dataIndex: 'revenue',
      key: 'revenue',
      render: (text: any, record: any) => {
        return(
          <span>{`$${formatNumberWithCommas(formatToTwoDecimalPlaces(text))}`}</span>
        )
    }
    //   render: (text: any) => `$${text.toLocaleString()}`,
    },
    {
        title: 'Total Revenue',
        dataIndex: 'totalRevenue',
        key: 'totalRevenue',
        render: (text: any, record: any) => {
            return(
              <span>{`$${formatNumberWithCommas(formatToTwoDecimalPlaces(text))}`}</span>
            )
        }

      //   render: (text: any) => `$${text.toLocaleString()}`,
      },
      {
        title: 'OBO Value',
        dataIndex: 'obo',
        key: 'obo',
        render: (text: any, record: any) => {
            return(
              <span>{`$${formatNumberWithCommas(formatToTwoDecimalPlaces(text))}`}</span>
            )
        }
      },
      {
        title: 'Action',
        dataIndex: 'action',
        key: 'action',
        render : (text: any, record: any,rowIndex:any) => {
            return(
                record.countOfWorkOrder > 0 && 
					<Button type='link' className = 'workOrder-button' onClick={()=>fetchWorkOrderDetails(record,{'levelName':"SOW",'levelData':record})}>{record.countOfWorkOrder} WOs</Button>
            )
        }
      }
  ];

  return (
    <Spin spinning={loading}>
      {/* Parent Opportunity Table */}
      <div style={{ marginBottom: '16px' }}>
        <Table
          dataSource={[parentOpp]} // Wrap parentOpp in an array to display as a single row
          columns={parentColumns}
          className='table-styles opportunity-details-table-container'
          rowKey={(record) => record.opportunityID}
          pagination={false}
          style={{
            borderRadius: '10px',
          }}
        //   bordered
        />
      </div>

      {/* SOW Details Section */}
      <div style={{ marginBottom: '16px' }}><span className='header-obo'> SOW</span> <span className='obo-count-label'>{parentOpp.countOfSow} </span></div>
      {<Table
        dataSource={sowData}
        columns={sowColumns}
        rowKey={(record) => record.sowID}
        className='table-styles obo-table-sow-details'
        pagination={{
          current: pageNo + 1,
          pageSize,
          total: totalCount,
          showSizeChanger: false,
        }}
        onChange={handleTableChange}
      />}
    </Spin>
  );
};
export default OboSowDetailsTableContainer;